<template>
  <div>
    <slot name="default">
      <v-text-field :label="$attrs['label'] ? $attrs['label'] : 'انتخاب دسته‌بندی'" :single-line="false"
                    :value="selectedItems.map(item => item.display).join(', ')" class="rounded-lg" clearable dense
                    outlined @click="dialog = true" @keyup.enter="dialog = false" @click:clear="selectedItems = []"/>
    </slot>

    <custom-popup v-model="dialog" :cons="cons" max-width="640">
      <v-card class="pa-4" flat>
        <div class="sticky-top white pb-4" style="top: 68px">
          <v-card-title class="justify-end pa-0">
            <v-btn :disabled="!selectedItems.length" class="rounded-lg" color="red" text @click="selectedItems = []">
              حذف همه
            </v-btn>
          </v-card-title>

          <v-chip-group column multiple>
            <v-chip v-for="(chip, i) in selectedItems" :key="i" :value="chip.value" class="rounded-pill" close
                    color="red"
                    outlined small @click:close="removeItem(chip)">
              {{ chip.display }}
            </v-chip>
          </v-chip-group>

          <div class="my-4">
            <v-text-field v-model="searching" clearable dense hide-details label="جستجو در دسته‌بندی" outlined/>
          </div>
        </div>

        <template v-if="!!search && search.length > 1">
          <template
              v-for="(cat, i) in searchedItems">
            <v-list-item :key="i" dense @click="selectSearched(cat)">
              <v-list-item-avatar size="42">
                <v-img v-if="!!cat.data.icon && !!cat.data.icon.image_url_light" :src="cat.data.icon.image_url_light"/>

                <v-icon v-else>mdi-view-grid-outline</v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title style="font-size: 1.2em;line-height: 1.2em">
                  {{ cat.data.display }}
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn v-if="multiple" icon>
                  <v-icon>mdi-{{ getChecked(cat) ? 'checkbox-marked' : 'checkbox-blank-outline' }}</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>
        </template>

        <template v-else>
          <v-list v-if="currentCategories" dense>
            <v-list-item v-if="!!parentCategory" @click="goBack">
              <v-list-item-action>
                <v-icon>mdi-arrow-right</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title style="font-size: 1.2em;line-height: 1.2em">
                  {{ parentCategory.data.display }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <template v-for="(cat, i) in currentCategories">
              <v-list-item :key="i" dense @click="showChildren(cat)">
                <v-list-item-avatar size="42">
                  <v-img v-if="!!cat.data.icon && !!cat.data.icon.image_url_light" :src="cat.data.icon.image_url_light"/>

                  <v-icon v-else>mdi-view-grid-outline</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title style="font-size: 1.2em;line-height: 1.2em">
                    {{ cat.data.display }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-icon v-if="!!cat.children && !!cat.children.length">mdi-chevron-left</v-icon>
                  <v-btn v-else icon>
                    <v-icon>mdi-{{
                        getChecked(cat) ? 'checkbox-marked' : isIndeterminate(cat, i) ? 'minus-box' : 'checkbox-blank-outline'
                      }}
                    </v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
        </template>
      </v-card>
    </custom-popup>
  </div>
</template>

<script>
import {debounce} from "@/core/plugins/TitleRibbon/install";

export default {
  name: "categoryPicker",

  props: {
    value: [Array, Object, String],
    multiple: Boolean,
    returnObject: Boolean,
    items: [Array, Object]
  },

  data() {
    return {
      loading: false,
      cons: {
        title: `انتخاب ${this.$attrs['label']}`,
        buttons: [
          // {type: 'submit', disabled: () => !this.canSelect, handler: () => this.submitSelect()}
          {type: 'submit', handler: this.submitSelect},
          {
            type: 'close', handler: () => {
              this.currentCategories = this.items
              this.parentCategory = null
              this.dialog = false
            }
          },
        ]
      },
      dialog: false,
      currentCategories: [],
      parentCategory: null,
      selectedItems: [],
      searching: '',
      search: ''
    }
  },

  mounted() {
    this.currentCategories = this.items;
  },

  watch: {
    searching(val) {
      debounce(() => {
        this.search = val
      }, 1200)
    }
  },

  computed: {
    searchedItems() {
      if (this.search?.length < 2) return []

      let items = []
      const getChildren = category => {
        if (!!category.children?.length)
          category.children.forEach(item => {
            getChildren(item)
          })
        else
          items.push({data: category.data})
      }

      this.items.forEach(item => getChildren(item))

      return items.filter(({data}) => data.search_keywords.toLowerCase().includes(this.search))
    }
  },

  methods: {
    submitSelect() {
      let value = null

      if (this.multiple) {
        if (this.returnObject) {
          value = this.selectedItems
        } else {
          value = this.selectedItems.map(item => item.value);
        }
      } else if (this.returnObject)
        value = this.selectedItems
      else
        value = this.selectedItems?.[0].value

      this.$emit('input', value)
      this.$emit('change', value)
      this.currentCategories = this.items
      this.parentCategory = null
    },
    selectSearched(category) {
      const {value, display} = category.data;

      if (!this.multiple) {
        this.selectedItems = [{value, display}];
      } else {
        const isItemSelected = this.selectedItems.findIndex(item => item.value === value);

        if (isItemSelected < 0) {
          // If the item is not selected, add it
          this.selectedItems.push({value, display});
        } else {
          // If the item is selected, remove it
          this.selectedItems.splice(isItemSelected, 1);
        }
      }
    },
    // Show the children of the selected category
    showChildren(category) {
      if (category.children?.length) {
        this.parentCategory = category; // store the parent category
        this.currentCategories = category.children;
      } else {
        const {value, display} = category.data;

        if (!this.multiple) {
          this.selectedItems = [{value, display}];
        } else {
          this.handleMultiple(category)
        }
      }
    },
    handleMultiple(category) {
      const {value, display} = category.data;
      const isItemSelected = this.selectedItems.some(item => item.value === value);
      const hasParent = this.selectedItems.some(item => value.includes(item.value));
      const isParent = value === this.parentCategory?.data?.value

      if (isParent && !isItemSelected) {
        this.selectedItems = [...this.selectedItems.reduce((arr, curr) => {
          if (!curr.value.includes(value))
            arr.push(curr)
          return arr
        }, []),
          {value, display}]
      } else if (isItemSelected) {
        const parentItemIndex = this.selectedItems.findIndex(item => item.value === value);
        // Remove the item if it's already selected
        this.selectedItems.splice(parentItemIndex, 1);

        // Retain selection of higher-level categories
        this.retainHigherLevelCategories(this.parentCategory);
      } else if (hasParent) {
        // If the item has a parent, remove the parent and add siblings
        const parentIndex = this.selectedItems.findIndex(item => value.includes(item.value));

        if (parentIndex >= 0) {
          this.selectedItems.splice(parentIndex, 1);
        }

        const siblings = this.parentCategory.children.slice(1).filter(item => item.data.value !== value).map(item => ({
          value: item.data.value,
          display: item.data.display,
        }));

        this.selectedItems.push(...siblings);
      } else if (!isItemSelected) {
        // If the item is not selected, add it
        this.selectedItems.push({value, display});
      } else {
        // If the item is selected, remove it
        this.selectedItems.splice(this.selectedItems.findIndex(item => item.value === value), 1);
      }

      // Check if all siblings are selected
      if (this.parentCategory.children
        .slice(1)
        .every(item => this.selectedItems.some(si => si.value === item.data.value))) {
        const p = {pv: this.parentCategory.data.value, pd: this.parentCategory.data.display}
        this.selectedItems = [...this.selectedItems.reduce((arr, curr) => {
          if (!curr.value.includes(this.parentCategory.data.value))
            arr.push(curr)

          return arr
        }, []),
          {value: p.pv, display: p.pd}]
      }
    },
    retainHigherLevelCategories(category) {
      // Base case: if there are no parent categories, return
      let parent = this.findParent(category)
      if (!parent) return;

      const parentValue = parent.data.value;
      const parentDisplay = parent.data.display;

      // Check if the parent is already selected
      if (!this.selectedItems.some(item => item.value === parentValue)) {
        this.selectedItems.push({value: parentValue, display: parentDisplay});
      }

      // Recursively check higher levels
      this.retainHigherLevelCategories(parent);
    },
    // Go back to the parent category
    goBack() {
      if (this.parentCategory) {
        // If there's a parent, find its parent's children or set root categories
        const parent = this.findParent(this.parentCategory);
        if (parent) {
          this.currentCategories = parent.children;
          this.parentCategory = parent;
        } else {
          this.currentCategories = this.items;
          this.parentCategory = null;
        }
      }
    },
    // Helper method to find the parent of the current category
    findParent(current) {
      const findRecursively = (categories) => {
        for (const category of categories) {
          if (category.children?.includes(current)) {
            return category;
          }

          if (!!category.children?.length) {
            const parent = findRecursively(category.children);
            if (parent) return parent;
          }
        }

        return null;
      };

      return findRecursively(this.items);
    },
    removeItem(chip) {
      let index = this.selectedItems.findIndex(item => item.value === chip.value)
      this.selectedItems.splice(index, 1)
    },
    getChecked(current) {
      let pv = this.parentCategory?.data.value

      return !!this.selectedItems?.map(item => item.value).includes(current.data.value)
        || this.selectedItems?.some(item => item.value === pv || pv?.includes(item.value))
    },
    isIndeterminate(category, index) {
      return index === 0
        && !this.selectedItems?.some(item => item.value === category.data.value)
        && !!this.selectedItems?.some(item => item.value.includes(this.parentCategory?.data?.value))
    }
  }
}
</script>